// jQuery(document).ready(function($) {
//     if (is_dev) {
//         jQuery('#whaa').remove();jQuery('<form id="whaa" style="   z-index: 100000;position: absolute; "><input type="hidden" value="31" name="product_id" /></form>').prependTo('body');
//         get_attach_custom_price_view(jQuery('#whaa')[0], 230);
//     }
// });

function update_product_price(elm) {
    var $ = jQuery.noConflict();
    elm = $(elm);


    var find_parent = function(elm) {
        var input_ids = ['#price', '#count', '#discount_type', '#discount', '#tax', '.taxes-included', '#amount_in', '#amount_ex'];
        var found_all = true;
        $.each(input_ids, function(i, selector) {
            if(elm.parent().find(selector).length == false) {
                found_all = false;
            }
        });
        if(found_all === true) {
            return elm.parent();
        } else {
            if(elm.hasClass('reveal')) {
                return false;
            }
            return find_parent(elm.parent());
        }
    };
    var parent = find_parent(elm);
    var inputs = {};
    if(parent !== false) {
        inputs = {
            price: parent.find('#price'),
            count: parent.find('#count'),
            discount_type: parent.find('#discount_type'),
            discount: parent.find('#discount'),
            tax: parent.find('#tax'),
            taxes_included: parent.find('.taxes-included'),
            amount_in: parent.find('#amount_in'),
            amount_ex: parent.find('#amount_ex'),
        };

        var calculate_price = function(price, count, discount_type, discount, tax, taxes_included, qry_tax) {
            price = parseFloat(price.replace(',','.').trim());
            count = parseFloat(count.replace(',','.').trim());
            discount = parseFloat(discount.replace(',','.').trim());
            var amount = price * count;

            if(discount > 0) {
                if(discount_type == "money") {
                    amount = amount - discount;
                } else {
                    amount = amount - (amount / 100 * discount);
                }
            }

            var amount_in = amount;
            var amount_ex = amount;

            if(taxes_included === true || tax == 0) {
                amount_ex = amount / (100 + tax) * 100;
            } else {
                amount_in = amount / 100 * (100 + tax);
            }

            if(qry_tax == 'in') {
                return amount_in;
            } else {
                return amount_ex;
            }
        }
        var tax_perc = parseFloat(inputs.tax.find('option[value='+inputs.tax.val()+']').attr('data-percentage').replace(',','.').trim());
        var calculated_price_in = calculate_price(inputs.price.val(), inputs.count.val(), inputs.discount_type.val(), inputs.discount.val(), tax_perc, inputs.taxes_included.is(':checked'), 'in');
        var calculated_price_ex = calculate_price(inputs.price.val(), inputs.count.val(), inputs.discount_type.val(), inputs.discount.val(), tax_perc, inputs.taxes_included.is(':checked'), 'ex');

        if(!isNaN(calculated_price_in)) {
            inputs.amount_in.show();
            inputs.amount_ex.show();
            inputs.amount_in.val('€ '+$.number(calculated_price_in, 2, ",", ".")+' inclusief '+tax_perc+'% BTW');
            inputs.amount_ex.val('€ '+$.number(calculated_price_ex, 2, ",", ".")+' exclusief '+tax_perc+'% BTW');
        } else {
            inputs.amount_in.hide();
            inputs.amount_ex.hide();
        }
    }
}
function add_product(vars) {
    const $ = jQuery.noConflict();

    if(typeof vars === 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/products/add',
        onOpen: function (elm, popup) {
            init_lifecycle_fields(elm);
            init_device_fields(elm);
            elm.find('select#category').productCategorySelector();

            elm.find('form').ajaxFormSubmit(function(data) {
                const after = function() {
                    $('body').doneLoading();
                    if(vars && vars.reload_item) {

                        $(vars.reload_item).reloadThisElement();
                    } else if(vars && vars.callback) {
                        vars.callback(data, elm, popup);
                    }
                    popup.close();
                    reload_location_if_needed(false);
                    if (!document.closeWindow) open_new_object(view_product, data);
                };
                if (elm.find('#is_device').is(':checked') && document.closeWindow) {
                    setTimeout(function() {
                        view_product(data.id, {callback: after, afterOpen: function(elm, popup) {
                                setTimeout(function () {
                                    elm.find('#link-to-device-info').click();
                                }, 500);
                            }});
                    }, 1000);
                } else {
                    after();
                }

            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function view_product(id, vars) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/products/view/'+id,
        onOpen: function(elm, popup) {

            if (vars !== undefined && vars.afterOpen) {
                vars.afterOpen(elm, popup);
            }
            init_lifecycle_fields(elm);
            init_device_fields(elm);
            elm.find('select#category').productCategorySelector();

            elm.find('#update_attached_devices').change(function() {
                const value = $(this).is(':checked');
                elm.find('.hard-override-input-wrapper').toggle(value);
                elm.find('.hard-override-input-wrapper input').prop('disabled', function(i, v) { return !value; });
            }).trigger('change');

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                squde_reload_for_flashes();
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup, document.closeWindow);
                } else {
                    reload_location_if_needed(document.closeWindow);
                }

                $('meta[name="type"][content="device"]').parents('.reveal').squdeReloadAjaxPopup();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_product(id,name) {
    var $ = jQuery.noConflict();

    name = decodeURI(name);
    custom_delete_with_confirmation("/products/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'product');

    return false;
}
function view_product_category(id, vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/products/viewCategory/'+id,
        onOpen: function(elm, popup) {

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
                reload_location_if_needed(document.closeWindow);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function add_product_category(id, vars) {
    var $ = jQuery.noConflict();

    if(typeof vars == 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/administration/add-category',
        onOpen: function (elm, popup) {
            var val = null;
            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars&& vars.callback) {
                    vars.callback(data, elm, popup);
                }
                reload_location_if_needed();
                if (!document.closeWindow) open_new_object(view_product_category, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_product_category(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    custom_delete_with_confirmation("/administration/productCategory/delete",id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'productcategory');

    return false;
}
function get_attach_custom_price_view(sender, client_id) {
    const $ = jQuery.noConflict();
    const vars = {};

    const form = $(sender);
    const formData = form.serializeJSON();
    const product_id = formData.product_id;


    $.squdeAjaxPopup({
        url: '/clients/attachCustomPriceView/'+client_id+'/'+product_id,
        onOpen: function (elm, popup) {
            elm.find('input[name="type"]').change(function() {
                const val = elm.find('input[name="type"]:checked').val();
                elm.find('label[for="price"], label[for="percentage"]').hide();
                elm.find('label[for="' + val + '"]').show().find('input').select().focus();
            }).trigger('change');


            elm.find('form').ajaxFormSubmit(function(data) {
                popup.close();
                if(vars != undefined && vars.reload_item != undefined) {
                    $('body').doneLoading();
                    //console.log(vars.reload_item);
                    //console.log($(vars.reload_item));
                    $(vars.reload_item).reloadThisElement();
                } else if(vars!= undefined && vars.callback != undefined) {
                    $('body').doneLoading();
                    vars.callback(data, elm, popup);
                }
                else {
                    reload_location_if_needed();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function detach_custom_price(id, client_id, name) {
    const $ = jQuery.noConflict();

    name = decodeURI(name);

    confirm("Weet u zeker dat de prijsafspraak van artikel \""+name+"\" wilt verwijderen van deze debiteur?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/clients/detachCustomPrice",
            data: {id:id,client_id:client_id},
            type: "POST",
            success: function(data) {
                $('.custom-products-table').reloadThisElement();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
function view_custom_price(client_id, product_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/clients/viewCustomPrice/'+client_id+'/'+product_id,
        onOpen: function (elm, popup) {
            elm.find('input[name="type"]').change(function() {
                const val = elm.find('input[name="type"]:checked').val();
                elm.find('label[for="price"], label[for="percentage"]').hide();
                elm.find('label[for="' + val + '"]').show().find('input').select().focus();
            }).trigger('change');

            elm.find('form').ajaxFormSubmit(function(data) {
                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function look_for_product_and_do_the_following(id, callback, ajaxObject = {}) {
    const $ = jQuery.noConflict();

    if(ajaxObject.product !== undefined) {
        ajaxObject.product.abort();
    }
    if(parseInt(id) > 0) {
        const client_id = look_for_new_client_id();
        ajaxObject.product = $.ajax({
            url: "/ajax/getProducts",
            data: {id: id, client_id: client_id},
            success: function(data) {
                if (!data[0]) {
                    callback(null);
                } else {
                    callback(data[0]);
                }
            }
        });
    }
}
function get_products(filters) {
    return jQuery.noConflict().ajax({
        url: '/ajax/specialSelectorSearch?v=&type=product',
        data: {filters, rawReturn: true},
    });
}
function init_lifecycle_fields(elm) {
    const $ = jQuery.noConflict();



    // Consumables are always deliverable
    const hasToBeDeliveredInput = elm.find('input[type="checkbox"][name="has_to_be_delivered"]');
    const consumableInput = elm.find('input[type="checkbox"][name="is_consumable"]');
    consumableInput.change(function() {
        const isConsumable = $(this).is(':checked');
        if (isConsumable) {
            hasToBeDeliveredInput.attr('disabled', 'disabled');
            hasToBeDeliveredInput.attr('data-previous-state', hasToBeDeliveredInput[0].checked);
            hasToBeDeliveredInput[0].checked = true;
        } else {
            hasToBeDeliveredInput.removeAttr('disabled');
            if (hasToBeDeliveredInput.is('[data-previous-state]')) {
                hasToBeDeliveredInput[0].checked = hasToBeDeliveredInput.attr('data-previous-state') === 'true';
            }
        }
    });


    // Toggle Information Wrapper
    const informationWrapper = elm.find('.lifecycle-information-wrapper');
    elm.find('input[type="checkbox"][name="has_lifecycle"]').change(function() {
        const isDevice = elm.find('input[type="checkbox"][name="is_device"]').is(':checked');
        const hasLifecycle = $(this).is(':checked');

        // Show or hide the lifecycle information wrapper
        informationWrapper.toggle(hasLifecycle);

        // If it has a lifecycle, it automatically gets to be a consumable
        if (hasLifecycle || isDevice) {
            consumableInput.attr('disabled', 'disabled');
            consumableInput.attr('data-previous-state', consumableInput[0].checked);
            consumableInput[0].checked = true;
        } else {
            consumableInput.removeAttr('disabled');
            if (consumableInput.is('[data-previous-state]')) {
                consumableInput[0].checked = consumableInput.attr('data-previous-state') === 'true';
            }
        }
        consumableInput.trigger('change');

    }).trigger('change');

    // Calculate the replacement in years / months / weeks
    informationWrapper.find(':input').change(function() {
        const numberOfUnits = parseInt(elm.find('#replace_after_0').val());
        const unit = elm.find('#replace_after_1').val();
        const margin = parseInt(elm.find('#replace_period_margin').val());

        let numberOfYears = 0;
        let numberOfMonths = 0;

        switch (unit) {
            case 'years':
                numberOfMonths = (numberOfUnits * 12) / 100 * margin;

                break;
            case 'months':
                numberOfMonths = numberOfUnits / 100 * margin;
                break;
        }
        while(numberOfMonths >= 12) {
            numberOfMonths -= 12;
            numberOfYears++;
        }
        numberOfMonths = Math.round(numberOfMonths);

        let str = '';
        if (numberOfYears > 0) {
            str = `${numberOfYears} jaar`;
            if (numberOfMonths > 0) {
                str += ' en ';
            }
        }
        if (numberOfMonths > 0) {
            str += `${numberOfMonths} maand`;
            if (numberOfMonths > 1) {
                str += 'en';
            }
        }
        elm.find('.replacement-string').html(str);
    });
    jQuery(informationWrapper.find(':input')[0]).trigger('change');
}
function init_device_fields(elm) {
    const $ = jQuery.noConflict();
    // Toggle Information Wrapper
    const informationWrapper = elm.find('.device-information-wrapper');

    elm.find('#is_device').unbind('change').change(function() {
        elm.find('#link-to-device-info').parent().toggle($(this).is(':checked'));
        informationWrapper.toggle($(this).is(':checked'));

        const mandatoryFields = [
            'is_consumable', 'has_to_be_delivered'
        ];
        const checked = $(this).is(':checked');
        mandatoryFields.forEach((field) => {
            const checkbox = elm.find(`#${field}`);
            const hidden = elm.find(`[name="${field}"][type="hidden"]`);
            if (checked) checkbox[0].checked = checked;
            if (['has_to_be_delivered', 'is_consumable'].includes(field)) {
                checkbox[0].disabled = checked;
                hidden.attr('value', checked ? 1 : 0);
            }
            checkbox.trigger('change');
        });
    });
    setTimeout(() => {
        elm.find('#is_device').trigger('change');
    });


    elm.find('#device_category_id').deviceCategorySelector().change(function() {
        show_the_right_device_meta_fields(elm, $(this));
    });
    elm.find('[data-product-selector]').productSelector();
}
function delete_product_consumable(product_id, consumable_id) {
    const $ = jQuery.noConflict();
    confirm('Weet u zeker dat u dit verbruiksartikel van dit artikel wilt verwijderen?', function() {
        $.post(`/products/removeConsumable/${product_id}/${consumable_id}`)
            .done(function() {
                squde_reload_for_flashes();
                reload_location_if_needed(false);
            })
            .fail(function(error) {
                console.error(error);
            });
    });
    return false;
}

function attach_consumable_to_product_from_select(sender, product_id) {
    const $ = jQuery.noConflict();
    attach_consumable_to_product(product_id, ($(sender).serializeJSON()).product_id);
    return false;
}
function attach_consumable_to_product(product_id, consumable_id) {
    jQuery.post(`/products/saveConsumable/${product_id}/${consumable_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        })
}

function disable_product(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm(`Weet u zeker dat u ${name} wilt deactiveren?`, () => {
        $('body').isLoading('dark');
        $.ajax({
            url: `/products/deactivate/${id}`,
            type: "POST",
            success: function() {
                squde_reload_for_flashes();
                reload_location_if_needed(false);
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}

function enable_product(id) {
    const $ = jQuery.noConflict();
    $.ajax({
        url: `/products/activate/${id}`,
        type: "POST",
        success: function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
            $('body').doneLoading();
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}
